function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { matchPath } from 'react-router-dom';
import { getLocalStorageItem, saveLocalStorageItem } from '@shared/utils/browserStorageUtils';
import { getFeedbackSubmittedTime, getComscorePresentedTime } from '@appsource/utils';
import { getWindow } from '@shared/services/window';
import { routes } from '@shared/routerHistory';
const npsMaxDeclinedDays = 14;
const npsMaxDeclinedDaysInMs = npsMaxDeclinedDays * 1000 * 3600 * 24;
const npsMaxSubmittedDays = 90;
const npsMaxSubmittedDaysInMs = npsMaxSubmittedDays * 1000 * 3600 * 24;
const feedbackMaxSubmittedDays = 14;
const feedbackSubmittedDaysInMs = feedbackMaxSubmittedDays * 1000 * 3600 * 24;
const comscoreMaxSubmittedDays = 14;
const comscoreMaxSubmittedDaysInMs = comscoreMaxSubmittedDays * 1000 * 3600 * 24;
const npsLocalStorageKey = 'nps';
let npsModule = null;
export const getNpsModule = ()=>{
    return npsModule;
};
const getEmptyNpsPersistentMetadata = ()=>{
    return {
        lastSubmittedTime: null,
        lastDismissedTime: null,
        lastCtaTime: null
    };
};
const getEmptyNpsMetadata = ()=>{
    return _object_spread_props(_object_spread({}, getEmptyNpsPersistentMetadata()), {
        pdpViewsCount: 0,
        searchActionsCount: 0,
        filterActionsCount: 0,
        galleryChangesCount: 0,
        categoryChangesCount: 0,
        paginationActionsCount: 0,
        seeAllActionsCount: 0
    });
};
const getNpsFromLocalStorage = ()=>{
    const npsMetadataTimesString = getLocalStorageItem(npsLocalStorageKey);
    try {
        const npsMetadata = JSON.parse(npsMetadataTimesString);
        return {
            lastSubmittedTime: Date.parse(npsMetadata === null || npsMetadata === void 0 ? void 0 : npsMetadata.lastSubmittedTime) ? new Date(npsMetadata.lastSubmittedTime) : null,
            lastDismissedTime: Date.parse(npsMetadata === null || npsMetadata === void 0 ? void 0 : npsMetadata.lastDismissedTime) ? new Date(npsMetadata.lastDismissedTime) : null,
            lastCtaTime: Date.parse(npsMetadata === null || npsMetadata === void 0 ? void 0 : npsMetadata.lastCtaTime) ? new Date(npsMetadata.lastCtaTime) : null
        };
    } catch (err) {
        return getEmptyNpsPersistentMetadata();
    }
};
const comscoreAlreadySubmitted = ()=>{
    var _lastPresentedTime_getTime;
    const lastPresentedTime = getComscorePresentedTime();
    if (!lastPresentedTime || !((_lastPresentedTime_getTime = lastPresentedTime.getTime) === null || _lastPresentedTime_getTime === void 0 ? void 0 : _lastPresentedTime_getTime.call(lastPresentedTime))) return false;
    return Date.now() - lastPresentedTime.getTime() < comscoreMaxSubmittedDaysInMs;
};
const feedbackAlreadySubmitted = ()=>{
    var _lastSubmittedTime_getTime;
    const lastSubmittedTime = getFeedbackSubmittedTime();
    if (!lastSubmittedTime || !((_lastSubmittedTime_getTime = lastSubmittedTime.getTime) === null || _lastSubmittedTime_getTime === void 0 ? void 0 : _lastSubmittedTime_getTime.call(lastSubmittedTime))) return false;
    return Date.now() - lastSubmittedTime.getTime() < feedbackSubmittedDaysInMs;
};
const otherFeedbacksAlreadySubmitted = ()=>{
    return feedbackAlreadySubmitted() || comscoreAlreadySubmitted();
};
const storeNpsModule = ()=>{
    if (npsModule) {
        const { lastCtaTime, lastDismissedTime, lastSubmittedTime } = npsModule.metadata;
        const objectToStore = {
            lastCtaTime,
            lastDismissedTime,
            lastSubmittedTime
        };
        saveLocalStorageItem(npsLocalStorageKey, JSON.stringify(objectToStore));
    }
};
const homePageMatch = ()=>{
    const currentPathname = getWindow().location.pathname.toLowerCase();
    return !!matchPath(`/:locale${routes.home.getPath()}`, currentPathname) || !!matchPath('/:locale', currentPathname);
};
class Nps {
    get metadata() {
        return this.npsMetadata;
    }
    hasDeclinedBefore() {
        var _lastDismissedTime_getTime;
        const lastDismissedTime = this.npsMetadata.lastDismissedTime;
        if (!lastDismissedTime || !((_lastDismissedTime_getTime = lastDismissedTime.getTime) === null || _lastDismissedTime_getTime === void 0 ? void 0 : _lastDismissedTime_getTime.call(lastDismissedTime))) return false;
        return Date.now() - lastDismissedTime.getTime() < npsMaxDeclinedDaysInMs;
    }
    hasSubmittedBefore() {
        var _lastSubmittedTime_getTime;
        const lastSubmittedTime = this.npsMetadata.lastSubmittedTime;
        if (!lastSubmittedTime || !((_lastSubmittedTime_getTime = lastSubmittedTime.getTime) === null || _lastSubmittedTime_getTime === void 0 ? void 0 : _lastSubmittedTime_getTime.call(lastSubmittedTime))) return false;
        return Date.now() - lastSubmittedTime.getTime() < npsMaxSubmittedDaysInMs;
    }
    hasCtaBefore() {
        var _lastCtaTime_getTime;
        const lastCtaTime = this.npsMetadata.lastCtaTime;
        if (!lastCtaTime || !((_lastCtaTime_getTime = lastCtaTime.getTime) === null || _lastCtaTime_getTime === void 0 ? void 0 : _lastCtaTime_getTime.call(lastCtaTime))) return false;
        return lastCtaTime.getTime() < Date.now();
    }
    calculateTotalActions() {
        const metadata = this.npsMetadata;
        return metadata.categoryChangesCount + metadata.pdpViewsCount + metadata.filterActionsCount + metadata.searchActionsCount + metadata.seeAllActionsCount + metadata.galleryChangesCount + metadata.paginationActionsCount;
    }
    checkForCompliance() {
        if (this.hasDeclinedBefore() || this.hasSubmittedBefore() || this.checkForOtherFeedbacks()) return;
        const totalActionsCount = this.calculateTotalActions();
        if (this.hasCtaBefore() && totalActionsCount >= 2 || totalActionsCount >= 10) {
            var _this_onVerified, _this;
            (_this_onVerified = (_this = this).onVerified) === null || _this_onVerified === void 0 ? void 0 : _this_onVerified.call(_this, this.npsMetadata);
        }
    }
    ctaClicked(trigger = true) {
        if (!homePageMatch()) {
            if (!(this.hasDeclinedBefore() || this.hasSubmittedBefore() || this.checkForOtherFeedbacks())) {
                this.npsMetadata.lastCtaTime = new Date();
                if (trigger) {
                    var _this_onVerified, _this;
                    (_this_onVerified = (_this = this).onVerified) === null || _this_onVerified === void 0 ? void 0 : _this_onVerified.call(_this, this.npsMetadata);
                }
            }
            this.npsMetadata.lastCtaTime = new Date();
            storeNpsModule();
        }
    }
    npsSubmitted() {
        this.npsMetadata.lastSubmittedTime = new Date();
        storeNpsModule();
    }
    npsDismissed() {
        this.npsUpdateLastDismissTime();
    }
    npsUpdateLastDismissTime() {
        this.npsMetadata.lastDismissedTime = new Date();
        storeNpsModule();
    }
    increaseActionsCounter(event) {
        if (!homePageMatch()) {
            this.npsMetadata[`${event}`] += 1;
            this.checkForCompliance();
        }
    }
    // eslint-disable-next-line no-useless-constructor
    constructor(npsMetadata, checkForOtherFeedbacks, onVerified){
        _define_property(this, "npsMetadata", void 0);
        _define_property(this, "checkForOtherFeedbacks", void 0);
        _define_property(this, "onVerified", void 0);
        this.npsMetadata = npsMetadata;
        this.checkForOtherFeedbacks = checkForOtherFeedbacks;
        this.onVerified = onVerified;
    }
}
export const initializeNpsModule = (onVerify)=>{
    const npsPersistentMetadata = getNpsFromLocalStorage();
    const npsMetadata = _object_spread({}, getEmptyNpsMetadata(), npsPersistentMetadata);
    npsModule = new Nps(npsMetadata, otherFeedbacksAlreadySubmitted, onVerify);
};
